import React from 'react'

interface StoreIconProps {
  size?: number | string
  color?: string
  className?: string
}

const StoreIcon: React.FC<StoreIconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="3"
      y="9"
      width="18"
      height="10"
      rx="2"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M2 9L4.5 4.5C4.78 4.02 5.29 3.7 5.85 3.7H18.15C18.71 3.7 19.22 4.02 19.5 4.5L22 9"
      stroke={color}
      strokeWidth="2"
      fill="none"
      strokeLinejoin="round"
    />
    <rect
      x="8"
      y="13"
      width="8"
      height="6"
      rx="1"
      fill={color}
      fillOpacity="0.15"
    />
    <line x1="8" y1="19" x2="8" y2="13" stroke={color} strokeWidth="2" />
    <line x1="16" y1="19" x2="16" y2="13" stroke={color} strokeWidth="2" />
  </svg>
)

export default StoreIcon
